import type { Breakpoint } from '@mui/material/styles';
import { useEffect, useMemo, useState } from 'react';
import { getOffer, type Offer } from '../../utils/offer';
import useBreakpointWidth from '../../utils/useBreakpointWidth';
import NoOfferCard from './NoOffer';
import OfferCard from './Offer';

export interface PromoCardProps {
    baseUrl?: string;
    breakpoint?: Breakpoint;
    originPage?: string;
    redirectPath?: string;
    position?: string;
}
const PromoCard = ({
    baseUrl = '',
    breakpoint,
    originPage = '',
    position = 'Homepage',
    redirectPath = '/sell-my-car',
}: PromoCardProps) => {
    const [offer, setOffer] = useState<Offer | null>();
    const [rendering, setRendering] = useState<boolean>(true);

    const breakpointWidth = useBreakpointWidth();
    const currentBreakpoint = useMemo(() => breakpoint ?? breakpointWidth, [breakpoint, breakpointWidth]);

    useEffect(() => {
        // This needs to be run on the client side.
        const ioOffer = getOffer();
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setOffer(ioOffer);
        // Add boolean check to avoid React Hydration errors
        setRendering(false);
    }, []);

    if (rendering) {
        return <></>;
    }

    if (offer && offer?.offerType == 'eligible') {
        return (
            <OfferCard
                baseUrl={baseUrl}
                breakpoint={currentBreakpoint}
                offer={offer}
                originPage={originPage}
                position={position}
                redirectPath={redirectPath}
            />
        );
    } else {
        return (
            <NoOfferCard
                baseUrl={baseUrl}
                breakpoint={currentBreakpoint}
                originPage={originPage}
                position={position}
                redirectPath={redirectPath}
            />
        );
    }
};

export default PromoCard;
